module.exports = __webpack_public_path__ + "img/57.08074f61.jpg";